import ToastSuccessAsset from '@/app/assets/imgs/toast-success.svg';

/** Exact Figma export, including the shadow that extends beyond the 18px layout box. */
export const ToastSuccessIcon = () => (
  <span aria-hidden="true" className="relative size-[18px] shrink-0">
    <span className="absolute inset-[-4.22%_-30.17%_-37.55%_-7.95%]">
      <img alt="" className="block size-full max-w-none" src={ToastSuccessAsset.src} />
    </span>
  </span>
);
